
import HeaderTitulo from "../../components/header-titulo";
import proposta from "./proposta";
import { SituacaoPropostaEnum } from "./../../classes/SituacaoPropostaEnum";
import propostaService from "../../services/propostaService";
import consultaService from "../../services/consultaService";

export default {
  name: "simulacao",
  props: ["propostaResponse"],
  components: { HeaderTitulo, proposta },
  data () {
    return {
      proposta: null,
      situacaoPropostaEnum: SituacaoPropostaEnum,
      isLoading: false,
      isLoadingRecusar: false,
      isLoadingAceitar: false,
      carenciaSolicitada: 0,
      carenciaMin: 0,
      carenciaMax: 0,
      chave: null,
      framework: {
        plugins: ["Loading"],
        config: {
          loading: {},
        },
      },
    };
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.proposta = this.propostaResponse.data;
      this.chave = this.proposta.chave;
      this.carenciaSolicitada = this.proposta.pzCarenciaAdicionadoFinalSelecionado
      this.carenciaMin = this.proposta.pzCarenciaAdicionadoFinal
      this.carenciaMax = this.proposta.pzCarenciaAdicionadoFinalMax
    },
    aceitar () {
      this.isLoadingAceitar = true;
      propostaService
        .aceitaProposta(this.proposta, this.proposta.chave)
        .then((res) => {
          if (res.data.code === 99) {
            this.$b.nError(`${res.data.message}`);
            return;
          }
          if (this.proposta.comprovacao) {
            if (this.proposta.tipoOperacao == 'RURAL') {
              this.$router.push({
                name: "comprovacaoRural",
                params: { propostaResponse: this.proposta },
              });
            } else {
              this.$router.push({
                name: "comprovacaoNaoRural",
                params: { propostaResponse: this.proposta },
              });
            }

          } else {
            this.$router.push({
              name: "aditivo",
              params: { propostaResponse: this.proposta },
            });
          }
        })
        .catch((err) => {
          this.$b.nError(`${err.data.message}`);
        })
        .finally(() => {
          this.isLoading = false;
          this.isLoadingAceitar = false;
        });
    },
    recusar () {
      this.isLoadingRecusar = true;
      propostaService
        .recusarProposta(this.proposta, this.proposta.chave)
        .then((res) => {
          if (res.data.code === 99) {
            this.$b.nError(`${res.data.message}`);
            return;
          }
          this.$router.push({ name: "propostaRecusada" });
        })
        .catch((err) => {
          this.$b.nError(`${err.data.message}`);
        })
        .finally(() => {
          this.isLoading = false;
          this.isLoadingRecusar = false;
        });
    },
    simular (val) {
      this.$q.loading.show();
      if (!this.chave || this.chave === undefined) {
        this.$b.nError(`Sem chave da proposta!`);
        return;
      }
      consultaService
        .simular(val, this.chave)
        .then((res) => {
          this.proposta = res.data.data;
          this.carenciaSolicitada = this.proposta.pzCarenciaAdicionadoFinalSelecionado
          this.carenciaMin = this.proposta.pzCarenciaAdicionadoFinal
          this.carenciaMax = this.proposta.pzCarenciaAdicionadoFinalMax
        })
        .catch((err) => {
          this.$b.nError(`${err.message}`);
        })
        .finally(() => {
          this.$q.loading.hide();
        });
    },
  },
};
